// import { getTranslations } from 'next-intl/server';
// import { Link } from '@/i18n/navigation';

// export default async function HomePage() {
//     const t = await getTranslations('HomePage');
//     return (
//         <div>
//             <h1>{t('title')}</h1>
//             <Link href="/about">{t('about')}</Link>
//         </div>
//     );
// }


"use client";

import { useRouter } from "@/i18n/navigation";
import { useEffect } from "react";

export default function HomePage() {
  const router = useRouter();

  useEffect(() => {
    router.push("/login");
  }, [router]);

  return null;
}
